// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__AGYoa","spinner":"Loader_spinner__NWlpt"};